const config = {
  nodeEnv: process.env.NODE_ENV,
  clientId: process.env.REACT_APP_CLIENT_ID,
  apiIssuer: process.env.REACT_APP_ISSUER,
  appUrl: process.env.REACT_APP_URL,
  appCode: process.env.REACT_APP_CODE,
};

export default config;
